import styled from 'styled-components';

const RedText = styled.span`
  line-height: var(--spectrum-global-font-line-height-small, 1.3);
  color: red;
`;

export default RedText;
